import {
  CREATE_INCIDENT_ASYNC,
  DATA_REQUEST_ASYNC,
  DATE_FILTER_CHANGE,
  FETCH_INCIDENTS_CSV_ASYNC,
  FILTER_CHANGE,
  LIST_CLOSE,
  LIST_INIT_AND_SHOW,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SEARCH_RESET,
} from './constants'

export const fetchData = () => ({ type: DATA_REQUEST_ASYNC.INITIATE })
export const fetchDataSuccess = (data) => ({
  type: DATA_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchDataError = (error) => ({
  type: DATA_REQUEST_ASYNC.ERROR,
  error,
})
export const fetchDataCancel = () => ({ type: DATA_REQUEST_ASYNC.CANCEL })

export const filterChange = (data) => ({ type: FILTER_CHANGE, payload: data })
export const dateFilterChange = (dateFilter) => ({
  type: DATE_FILTER_CHANGE,
  payload: { dateFilter },
})
const searchChange = (q) => ({ type: SEARCH_CHANGE, payload: { q } })
const searchReset = () => ({ type: SEARCH_RESET })

export const initialAndShowList = (filters, dateFilter, listType) => ({
  type: LIST_INIT_AND_SHOW,
  payload: { filters, dateFilter, listType },
})
const closeList = () => ({ type: LIST_CLOSE })

export const createIncident = (eid) => ({
  type: CREATE_INCIDENT_ASYNC.INITIATE,
  payload: { eid },
})
export const createIncidentSuccess = () => ({
  type: CREATE_INCIDENT_ASYNC.SUCCESS,
})
export const createIncidentError = (error) => ({
  type: CREATE_INCIDENT_ASYNC.ERROR,
  error,
})
export const createIncidentCancel = () => ({
  type: CREATE_INCIDENT_ASYNC.CANCEL,
})

const paginateChange = (page) => ({ type: PAGINATE_CHANGE, payload: { page } })

const fetchIncidentsCSV = () => ({ type: FETCH_INCIDENTS_CSV_ASYNC.INITIATE })
export const fetchIncidentsCSVSuccess = (data) => ({
  type: FETCH_INCIDENTS_CSV_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchIncidentsCSVError = (error) => ({
  type: FETCH_INCIDENTS_CSV_ASYNC.ERROR,
  error,
})
const fetchIncidentsCSVCancel = () => ({
  type: FETCH_INCIDENTS_CSV_ASYNC.CANCEL,
})

export default {
  // to props
  fetchData,
  fetchDataCancel,
  dateFilterChange,
  closeList,
  filterChange,
  searchChange,
  searchReset,
  createIncident,
  paginateChange,
  initialAndShowList,
  fetchIncidentsCSV,
  fetchIncidentsCSVCancel,
}
